// extracted by mini-css-extract-plugin
module.exports = {"bar":"DocTools_bar__oN3y9","label":"DocTools_label__wpOUf","actions":"DocTools_actions__lo9RM","btn":"DocTools_btn__7WrPe"};